import * as Yup from 'yup';

export const schema = Yup.object().shape({
  dataPagamento: Yup.date().nullable().required('Selecione uma data do pagamento'),
});
